import Joi from 'joi';

import { requiredString } from '../../../utils/validators';
import { FormValues } from './types';

export const validationSchema = Joi.object<FormValues, true>({
  selectedClassId: requiredString,
});
